import { useEffect, useRef, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DURATION = 5000;

function SplashLogo({ branding }) {
  if (branding?.logo_version) return <img className="splash-logo" src={`${API}/branding/logo?v=${branding.logo_version}`} alt={branding.name || "Emlak Sepeti"} data-testid="welcome-splash-logo" />;
  return <div className="brand splash-logo splash-brand" data-testid="welcome-splash-logo"><span className="brand-mark">₺</span><span>Emlak <b>Sepeti</b></span></div>;
}

export function WelcomeSplash({ branding, onDone }) {
  const [leaving, setLeaving] = useState(false);
  const done = useRef(false);
  const text = branding?.texts?.login_splash ?? "Hoş Geldiniz";
  const finish = () => { if (!done.current) { done.current = true; onDone(); } };
  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), DURATION - 550);
    const t2 = setTimeout(finish, DURATION);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const skip = () => { setLeaving(true); setTimeout(finish, 450); };
  return (
    <div className={leaving ? "splash leaving" : "splash"} onClick={skip} data-testid="welcome-splash">
      <div className="splash-glow" />
      <div className="splash-center">
        <div className="splash-logo-wrap"><span className="splash-ring" /><span className="splash-ring r2" /><SplashLogo branding={branding} /></div>
        {text && <h1 className="splash-title" data-testid="welcome-splash-text" aria-label={text}>{[...text].map((ch, i) => <span key={i} style={{ animationDelay: `${1.1 + i * 0.06}s` }}>{ch === " " ? "\u00a0" : ch}</span>)}</h1>}
        <i className="splash-line" />
      </div>
      <div className="splash-progress"><i /></div>
      <small className="splash-hint" data-testid="welcome-splash-hint">Geçmek için ekrana dokunun</small>
    </div>
  );
}
